import React, { useCallback, useEffect, useState } from 'react';
import FlowHandlingButtons from '../Common/HandleNavigationAndSubmit';
import { contentIsNotNull } from '../Common/Validator';
import { spaceListingData } from '../Common/ProfileListingDataModal';
import { IMAGE_CLOUD_FOLDER, IMAGE_CLOUD_NAME, IMAGE_CLOUD_PRESET } from '../../../settings';
import { getProfileData, setProfileData } from '../Common/DataController';
import { DEFAULT_DATA_OBJ } from '../SpaceListingConstants';
import { Col, Row, Icon } from 'antd';
import uploadIcon from '../../../assets/images/space-listing/uploadIcon.svg';
import checkIconWhite from '../../../assets/images/space-listing/check-icon-white.svg';
import deleteIconWhite from '../../../assets/images/space-listing/delete-white.svg';
import checkIconGreen from '../../../assets/images/space-listing/check-icon-green.svg';
import { useParams, useLocation } from 'react-router-dom';

const UploadImages = ({ currentBlock }) => {
  const { country } = useParams();
  const location = useLocation();
  const [uploadImageDetails, setUploadImageDetails] = useState(getProfileData()?.[DEFAULT_DATA_OBJ] ? getProfileData() : spaceListingData(country));
  const [isNextBtnActive, setIsNextBtnActive] = useState(false);



  useEffect(() => {
   const isImages = getFieldCurrentValue('uploadedImages').filter(key => key?.resource_type !== 'video')
   setIsNextBtnActive(contentIsNotNull(isImages, 0, 10));
  }, [uploadImageDetails]);

  const handleUploadImages = useCallback((name, newValue) => {
    if (newValue) {
      const tempObj = Object.assign({}, uploadImageDetails, {
        ...uploadImageDetails,
        uploading_images: uploadImageDetails?.[currentBlock].map((value) => {
          value['uploadedImages'].push(newValue);
          return value;
        }),
      });
      setProfileData(tempObj);
      setUploadImageDetails(tempObj);
    }
  }, []);

  const changeSelectedImage = useCallback((name, newValue) => {
    if (newValue) {
      const tempObj = Object.assign({}, uploadImageDetails, {
        ...uploadImageDetails,
        uploading_images: uploadImageDetails?.[currentBlock].map((value) => {
          value['selectedImage'] = newValue;
          return value;
        }),
      });
      setProfileData(tempObj);
      setUploadImageDetails(tempObj);
    }
  }, []);

  const removeSelectedImage = (id) => {
    const tempObj = Object.assign({}, uploadImageDetails, {
      ...uploadImageDetails,
      uploading_images: uploadImageDetails?.[currentBlock].map((value) => {
        value['uploadedImages'] = value['uploadedImages'].filter((value1, index1) => value1?.asset_id !== id);
        return value;
      }),
    });
    setProfileData(tempObj);
    setUploadImageDetails(tempObj);
  };

  const removeSelectedVideo = (id) => {
    const tempObj = Object.assign({}, uploadImageDetails, {
      ...uploadImageDetails,
      uploading_images: uploadImageDetails?.[currentBlock].map((value) => {
        value['uploadedImages'] = value['uploadedImages'].filter((value1, index1) => value1?.asset_id !== id);
        return value;
      }),
    });
    setProfileData(tempObj);
    setUploadImageDetails(tempObj);
  };

  const getFieldCurrentValue = (type) => {
    return getProfileData()?.[currentBlock]?.[0]?.[type];
  };

  const openWidget = () => {
    window.cloudinary.openUploadWidget(
      {
        cloud_name: IMAGE_CLOUD_NAME,
        upload_preset: IMAGE_CLOUD_PRESET,
        theme: 'white',
        folder: IMAGE_CLOUD_FOLDER,
        client_allowed_formats: ['png', 'jpeg', 'pdf'],
        cropping: 'true',
        croppingCoordinatesMode: 'custom',
      },
      (error, result) => {
        if (!error && result && result?.event === 'success' && result?.info !== null && result?.info !== undefined) {
          handleUploadImages('uploadedImages', result?.info);
          changeSelectedImage('selectedImage', result?.info?.['asset_id']);
        }
      }
    );
  };

  const openVideoWidget = () => {
    window.cloudinary.openUploadWidget(
      {
        cloud_name: IMAGE_CLOUD_NAME,
        upload_preset: IMAGE_CLOUD_PRESET,
        theme: 'white',
        folder: IMAGE_CLOUD_FOLDER,
        client_allowed_formats: ['mp4'],
        cropping: 'true',
        croppingCoordinatesMode: 'custom',
      },
      (error, result) => {
        if (!error && result && result?.event === 'success' && result?.info !== null && result?.info !== undefined) {
          handleUploadImages('uploadedImages', result?.info);
          // changeSelectedImage('selectedImage', result?.info?.['asset_id']);
        }
      }
    );
  };

  const selectImage = (asset_id) => {
    changeSelectedImage('selectedImage', asset_id);
  };

  return (
    <>
      <div className="left-side-inner-wrapper upload-img-page">
        <h1 className="listing-page-title">Uploads</h1>
        <p className="listing-page-description">
          Upload your best images. The human brain processes visuals up to 60,000 times faster than text: the better the images, the more bookings you’ll get!
        </p>

        <div className="sl-upload-container">
          <Row gutter={32}>
            {/* Images Column */}
            <Col md={12} sm={24}>
              <div className="sl-upload-section">
                <h4 className="sl-upload-label">Images</h4>
                <div className="sl-dropzone" onClick={() => openWidget(true)}>
                  <div className="sl-dropzone-inner">
                    <div className="sl-upload-icon-circle">
                      <Icon type="cloud-upload" />
                    </div>
                    <p className="sl-dropzone-text">
                      {/* Drag & drop files or */}
                      <span className="sl-upload-link">Upload</span>
                    </p>
                    <p className="sl-dropzone-hint">Supported formats: JPEG, PNG</p>
                  </div>
                </div>
                <p className="sl-resolution-text">Minimum image resolution is 800 x 410px</p>

                <div className="sl-preview-grid">
                  <Row gutter={[8, 8]}>
                    {getFieldCurrentValue('uploadedImages') &&
                      getFieldCurrentValue('uploadedImages')
                        .filter((value) => value?.resource_type == 'image')
                        .map((value, index) => (
                          <Col span={8} key={value?.asset_id}>
                            <div 
                              className={`sl-preview-card ${value?.['asset_id'] === getFieldCurrentValue('selectedImage') ? 'is-primary' : ''}`}
                              onClick={() => selectImage(value?.['asset_id'])}
                            >
                              <img src={value.url} alt="preview" />
                              <div className="sl-preview-overlay">
                                <Icon type="delete" onClick={(e) => { e.stopPropagation(); removeSelectedImage(value?.asset_id); }} />
                                {value?.['asset_id'] === getFieldCurrentValue('selectedImage') ? <Icon type="check-circle" theme="filled" /> : <Icon type="star" onClick={(e) => { e.stopPropagation(); selectImage(value?.asset_id); }} />}
                              </div>
                            </div>
                          </Col>
                        ))}
                  </Row>
                </div>
              </div>
            </Col>

            {/* Videos Column */}
            <Col md={12} sm={24}>
              <div className="sl-upload-section">
                <h4 className="sl-upload-label">Videos</h4>
                <div className="sl-dropzone" onClick={() => openVideoWidget(true)}>
                  <div className="sl-dropzone-inner">
                    <div className="sl-upload-icon-circle">
                      <Icon type="cloud-upload" />
                    </div>
                    <p className="sl-dropzone-text">
                      {/* Drag & drop files or */}
                      <span className="sl-upload-link">Upload</span>
                    </p>
                    <p className="sl-dropzone-hint">Supported formats: MP4, 3GP</p>
                  </div>
                </div>
                <p className="sl-resolution-text">
                  Maximum video resolution is 800 x 410px and duration is 1 minute and the capacity is 100 MB.
                </p>

                <div className="sl-preview-grid">
                  <Row gutter={[8, 8]}>
                    {getFieldCurrentValue('uploadedImages') &&
                      getFieldCurrentValue('uploadedImages')
                        .filter((value) => ['mp4', '3gp']?.includes(value?.format))
                        .map((value, index) => (
                          <Col span={8} key={value?.asset_id}>
                            <div className="sl-preview-card is-video">
                              <video src={value.url} />
                              <div className="sl-preview-overlay">
                                <Icon type="delete" onClick={(e) => { e.stopPropagation(); removeSelectedVideo(value?.asset_id); }} />
                              </div>
                            </div>
                          </Col>
                        ))}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <FlowHandlingButtons isActive={isNextBtnActive} />
    </>

  );
};

export default UploadImages;
